import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs/index';
import { catchError, map, switchMap } from 'rxjs/operators';
import { TrackableItemsActions } from './trackable-items.actions';
import { TrackableItemsService } from "./trackable-items.service";

@Injectable()
export class TrackableItemsEffects {
    constructor(
        private actions$: Actions,
        private trackableItemsService: TrackableItemsService) {
    }

  getItemCategory: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(TrackableItemsActions.getItemCategory),
      switchMap((action: any) =>
        this.trackableItemsService.getItemCategory(action.userId)
          .pipe(
            map((payload: any) =>
              TrackableItemsActions.getItemCategorySuccess({ payload})
            ),
            catchError(error =>
              of(TrackableItemsActions.getItemCategoryFail({ error }))
            )
          )
      )
    )
  );


  getItemTypes: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(TrackableItemsActions.getItemTypes),
      switchMap((action: any) =>
        this.trackableItemsService.getItemTypes(action.userId)
          .pipe(
            map((payload: any) =>
              TrackableItemsActions.getItemTypesSuccess({ payload})
            ),
            catchError(error =>
              of(TrackableItemsActions.getItemTypesFail({ error }))
            )
          )
      )
    )
  );

  getStates: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(TrackableItemsActions.getStates),
      switchMap((action: any) =>
        this.trackableItemsService.getStates(action.userId)
          .pipe(
            map((payload: any) =>
              TrackableItemsActions.getStatesSuccess({ payload})
            ),
            catchError(error =>
              of(TrackableItemsActions.getStatesFail({ error }))
            )
          )
      )
    )
  );

  getLocationTypes: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(TrackableItemsActions.getLocationTypes),
      switchMap((action: any) =>
        this.trackableItemsService.getLocationTypes(action.userId)
          .pipe(
            map((payload: any) =>
              TrackableItemsActions.getLocationTypesSuccess({ payload})
            ),
            catchError(error =>
              of(TrackableItemsActions.getLocationTypesFail({ error }))
            )
          )
      )
    )
  );

  getLocations: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(TrackableItemsActions.getLocationTypes),
      switchMap((action: any) =>
        this.trackableItemsService.getLocations(action.userId)
          .pipe(
            map((payload: any) =>
              TrackableItemsActions.getLocationsSuccess({ payload})
            ),
            catchError(error =>
              of(TrackableItemsActions.getLocationsFail({ error }))
            )
          )
      )
    )
  );
}
